import { useMemo } from 'react';
import { useLocation } from 'react-router';

/**
 * Custom hook that converts the current path to a stripped route
 * This is to normalized routes for Cloudwatch RUM analytics.
 * Example: /user/123/posts/456 → /user/:id/posts/:id
 */
const useStrippedPath = (): string => {
  const location = useLocation();
  const { pathname } = location;

  return useMemo(() => {
    const segments = pathname.split('/');

    const processedSegments = segments.map(segment => {
      if (!segment) return segment; // Handle empty segments (leading/trailing slashes)

      // Replace segments that are strings of numbers with :id
      if (/^\d+$/.test(segment)) {
        return ':id';
      }

      // Leave non-numeric segments as-is
      return segment;
    });

    return processedSegments.join('/');
  }, [pathname]);
};

export default useStrippedPath;
